import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'antd'

class FormikFieldAntdInputWrapper extends React.Component {
  constructor (props) {
    super(props)
    // this.inputRef = React.createRef() // was useful for forcing focus
    this.onChange = this.onChange.bind(this)
  }

  onChange (e) {
    let fieldText = e.target.value
    if (!this.props.emptyAllowed && !fieldText) {
      fieldText = this.props.fallback
    }
    // updates Formik
    this.props.form.setFieldValue(this.props.field.name, fieldText)
    // updates Firestore
    this.props.updateField(fieldText)
  }

  render () {
    let defaultValue = this.props.field.value
    if (defaultValue === this.props.fallback) {
      defaultValue = ''
    }

    const passedProps = {
      // ref: this.inputRef, // was useful for forcing focus
      id: this.props.id,
      className: this.props.className,
      name: this.props.field.name,
      defaultValue,
      placeholder: this.props.fallback,
      maxLength: this.props.maxLength,
      onChange: this.onChange
    }

    if (this.props.type === 'INPUT') {
      return <Input {...passedProps} />
    } else if (this.props.type === 'TEXTAREA') {
      return <Input.TextArea {...passedProps} autosize={true} />
    }
  }
}

FormikFieldAntdInputWrapper.propTypes = {
  type: PropTypes.oneOf(['INPUT', 'TEXTAREA']).isRequired,
  emptyAllowed: PropTypes.bool.isRequired,
  updateField: PropTypes.func.isRequired,
  fallback: PropTypes.string
}

export default FormikFieldAntdInputWrapper



// WEBPACK FOOTER //
// ./src/components/FormikFieldAntdInputWrapper.js